export default __webpack_public_path__ + "static/media/villa_5.437c564e.jpg";